<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

const shouldBeWebhookUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export default {
  components: {
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      webhookUrl: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    webhookUrl: { shouldBeWebhookUrl },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const apiChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: {
            type: 'api',
            webhook_url: this.webhookUrl,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: apiChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.API_CHANNEL.API.ERROR_MESSAGE'), {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full flex flex-col gap-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.API_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.API_CHANNEL.DESC')"
    />
    <form class="flex w-full flex-col" @submit.prevent="createChannel()">
      <!-- Layout 2 cột -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Cột trái: Channel Name -->
        <div>
          <label :class="{ error: v$.channelName.$error }">
            {{ $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.LABEL') }}
            <input
              v-model="channelName"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
              "
              @blur="v$.channelName.$touch"
            />
            <span v-if="v$.channelName.$error" class="message">{{
              $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.ERROR')
            }}</span>
          </label>
        </div>

        <!-- Cột phải: Webhook URL -->
        <div>
          <label :class="{ error: v$.webhookUrl.$error }">
            {{ $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.LABEL') }}
            <input
              v-model="webhookUrl"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.PLACEHOLDER')
              "
              @blur="v$.webhookUrl.$touch"
            />
            <span v-if="v$.webhookUrl.$error" class="message">{{
              $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.ERROR')
            }}</span>
          </label>
          <p class="help-text mt-2">
            {{ $t('INBOX_MGMT.ADD.API_CHANNEL.WEBHOOK_URL.SUBTITLE') }}
          </p>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="w-full flex justify-center mt-12">
        <woot-submit-button
          class="!bg-n-bluegray-4 !text-white rounded-lg"
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.API_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<style scoped>
.help-text {
  font-size: 0.875rem;
  color: #6b7280;
}
</style>